import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

import { useState } from 'react';
import { Link as RouterLink, useLocation, useParams, useNavigate, useNavigation } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Container, Fab, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { toast } from 'react-toastify';
import { BaseURL } from '../../common/URLs';
import { Constants } from 'ag-grid-community';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { HELPDESK_ROLES } from '../../common/constants';
import { loaderService } from '../../common/custom-loader/loader-service';
import { AddIcon, CloseIcon, DeleteIcon, SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

function AddEditPage() {
    const auth = 'Bearer ' + getLocalStorageItem('id_token');
    const location = useLocation();
    const { id } = useParams();
    // const history = useNavigation();

    const [Flag, setFlag] = useState(null);
    const [isSubDisbaled, setSubDisabled] = useState(true);
    const [isSubCatSelected, setIsSubCatSelected] = useState(false);
    const [getCategory, setCategory] = useState("");
    const [getSubCat, setSubCatName] = useState("");
    const [respData, setRespData] = useState([]);
    const [resp1Data, setResp1Data] = useState([])
    const navigate = useNavigate();
    const [answer, setAnswer] = useState('');
    const [catsub, setCatsub] = useState([]);
    const [characterLimit] = useState(200);
    const [valchecker, setValchecker] = useState(false);
    const [special, setSpecial] = useState(false);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
     const [isApiCalled, setIsApiCalled] = useState(false);

    const [inputFields, setInputFields] = useState([{
        fqaQuestion: '',
        fqaAnswer: '',
        grievanceCategory: '',
        grevanceSubCategory: '',
        extFlag: localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,
    }]);

    const addInputField = () => {
        setInputFields([...inputFields, {
            'fqaQuestion': '',
            'fqaAnswer': '',
            'grievanceCategory': getCategory,
            'grevanceSubCategory': getSubCat,
            extFlag: localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,

        }])
    }
    // /////////////////  question //////////////////

    const [question, setQuestion] = useState('');

    const handleChangeQuestion = (index, evnt) => {
        const { name, value } = evnt.target;
        const list = [...inputFields];
        list[index][name] = VALIDATION.noSpecialCharacterValidation(capitalizeFunction(value));
        setInputFields(list);
    };


    const handleChangeAnswer = (index, evnt) => {
        const { name, value } = evnt.target;
        const list = [...inputFields];
        list[index][name] = value;
        setInputFields(list);
    };

    const removeInputFields = (index) => {
        const rows = [...inputFields];
        rows.splice(index, 1);
        setInputFields(rows);
    }


    //Code for getting sub-category from category
    function handleCategoryChange(e) {
        setCategory(e.target.value);
        setSubDisabled(false);
        setIsSubCatSelected(false);
        setFaq([]);

        const list = [...inputFields];
        list.map((listItem) => { return listItem['grievanceCategory'] = e.target.value });
        setInputFields(list);
        //setCategory(getCategory) 
    }


    function handleSubCategoryChange(e) {
        // setOpen(e)
        setSubCatName(e.target.value);
        setIsSubCatSelected(true);

        const list = [...inputFields];
        list.map((listItem, index) => { return listItem['grevanceSubCategory'] = e.target.value });
        setInputFields(list);
    }
    ///////////////////////////////////////////////


    useEffect(() => {
        //managefaq()
        fetchCatagory();

    }, [])

    //fetchCategoryAndSubcategory API
    const fetchCatagory = () => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
            {},
            {
                headers: {
                    "Authorization": auth,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? true : false
                },
            }
        ).then((response) => {
            // console.log("Success - ", response);
            setRespData(response.data);
            loaderService.hideLoader();
            // console.log(respData, "responseData");

        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    //////////////////////////////////////////////////////////////////
    /////adding data in api
    // const onConfirmSubmit = () => {
    //     handleConfirmLogModalClose();
    //     adddata();
    // }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await adddata();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };
    const adddata = () => {
        let onSaveForm = {
            "helpdeskFrequentAskQuestionEntity":
                inputFields,


        }
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/CreateMultFaq",
            onSaveForm,
            {
                headers: {

                    "Authorization": auth
                },
            }
        ).then((response) => {
            response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description);
            // navigate('../manage-faq');
            fetchCatagory();
            setRespData(response.data)
            setCategory("");
            setSubCatName("");
            setInputFields([{
                fqaQuestion: '',
                fqaAnswer: '',
                grievanceCategory: '',
                grevanceSubCategory: '',
                // extFlag: localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,
            }]);
            //setLoading(false)
            loaderService.hideLoader();
        }).catch((error) => {
            console.log(error);
            toast.error('Please try again !')
            loaderService.hideLoader();
        })

    }

    function submit() {
        var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
        let lengthcheck = 'false';
        let specialcheck = 'false';
        for (let index = 0; index < inputFields.length; index++) {
            if (inputFields[index].fqaQuestion.length > 200) {
                lengthcheck = 'true'
                break
            }
            else if (inputFields[index].fqaAnswer.length > 200) {
                lengthcheck = 'true'
                break
            }
            else if (regex.test(inputFields[index].fqaQuestion)) {
                specialcheck = 'true'
                break
            }
            else if (regex.test(inputFields[index].fqaAnswer)) {
                specialcheck = 'true'
                break
            }
        }
        if (inputFields) {
            inputFields.every(item => {
                if (!item.fqaQuestion) {
                    toast.error("Please enter question!")
                }
                else if (!item.fqaAnswer) {
                    toast.error("Please write answer!")
                }
                else if (lengthcheck == 'true') {
                    toast.error('please enter the question or answer within 200 words')
                }
                else {
                    handleConfirmLogModalOpen();
                    // adddata()
                }
            })
            // else if (specialcheck=='true') {
            //     toast.error('please do not use any special chreacter')
            //     }
        }
        else {
            toast.error('Please write FAQ or FAQA')
        }
    }

    const [getFaq, setFaq] = useState([])
    const helpTopics = [...getFaq];

    const onCancel = () => {
        setCategory("");
        setSubCatName("");
        setInputFields([{
            fqaQuestion: '',
            fqaAnswer: '',
            grievanceCategory: '',
            grevanceSubCategory: '',
            // extFlag: localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,
        }]);
    }

    const categoryList = localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? respData?.External_category : respData?.Helpdesk_category

    return (
        <>
            <Helmet>
                <title> ManageFaqEdit/Add | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">

                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../manage-faq' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  Manage FAQ

                </Typography>
                <Card >
                    <Stack spacing={2} sx={{ p: 1 }}>


                        <FormControl sx={{ width: '30%' }}>
                            <InputLabel id="select-category-label">Category</InputLabel>
                            <Select
                                labelId="select-category-label"
                                id="select-category"
                                label="category"

                                defaultValue={getCategory}
                                //  defaultValue={FaqArray.grievanceCategory}
                                value={getCategory}
                                onChange={handleCategoryChange}
                            //onClick={() => fetchCategory()}
                            >

                                <MenuItem value="">
                                    <em>Select</em>
                                </MenuItem>
                                {categoryList?.map(function (categoryList, i) {
                                    return <MenuItem key={categoryList} value={categoryList}>{categoryList}</MenuItem>
                                })}

                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '30%' }}>

                            <InputLabel id="select-subCategory-label"> Sub-Category</InputLabel>
                            <Select
                                labelId="select-subCategory-label"
                                id="select-subCategory"
                                label="Sub-Category"
                                defaultValue={getSubCat}
                                value={getSubCat}
                                onChange={handleSubCategoryChange}
                            >

                                {respData && respData[`${getCategory}`]?.map(function (subcat, i) {
                                    return <MenuItem key={subcat} value={subcat}>
                                        {subcat}</MenuItem>
                                })}

                            </Select>

                        </FormControl>

                        {
                            inputFields.map((data, index) => {
                                const { fqaQuestion, fqaAnswer } = data;

                                return (
                                    <div key={index}>
                                        <TextField fullWidth
                                            autoComplete="off"
                                            //  id="outlined-multiline-static"
                                            label="Question"
                                            multiline
                                            color="info"
                                            rows={5}
                                            name='fqaQuestion'
                                            onChange={(event) => handleChangeQuestion(index, event)}

                                            value={fqaQuestion}

                                            sx={{ paddingRight: '15%', paddingBottom: '2%' }}
                                        />
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                            <Badge bg={`${fqaQuestion.length > characterLimit ? 'danger' : 'primary'}`}>{fqaQuestion.length}/{characterLimit}</Badge>
                                        </div>

                                        <TextField fullWidth
                                            autoComplete="off"
                                            //  id="outlined-multiline-static"
                                            label="Answer"
                                            multiline
                                            color="info"
                                            rows={5}
                                            name='fqaAnswer'
                                            onChange={(event) => handleChangeAnswer(index, event)}
                                            value={fqaAnswer}

                                            sx={{ paddingRight: '15%' }}

                                        />
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                            <Badge bg={`${fqaAnswer.length > characterLimit ? 'danger' : 'primary'}`}>{fqaAnswer.length}/{characterLimit}</Badge>
                                        </div>

                                        {
                                            (inputFields.length !== 1) ? <Typography component={'span'} sx={{ mt: 2, mr: '8%', display: 'flex', justifyContent: 'flex-end' }} variant='body2' align='justify'><Button
                                                onClick={() => removeInputFields(index)} color="error" variant="contained" startIcon={<DeleteIcon />}>Remove</Button>   </Typography> : ''}
                                    </div>
                                )
                            })
                        }
                    </Stack>
                    <Typography component={'span'} sx={{ mt: 2, mr: '8%', display: 'flex', justifyContent: 'flex-end' }} variant='body2' align='justify'>
                        <Button variant="contained" startIcon={<AddIcon />} color="primary" sx={{ textTransform: 'none', borderRadius: 0.5 }} size="medium" onClick={addInputField} >
                            Add a question
                        </Button>
                    </Typography>
                    &nbsp;
                    &nbsp;
                    <Box display='flex' alignItems="center" justifyContent="center">
                        <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" onClick={() => onCancel()} startIcon={<CloseIcon />}>Cancel</Button>
                        &nbsp;
                        &nbsp;
                        {/* <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" component={RouterLink} to='../manage-faq'>Cancel</Button> */}
                        <Button sx={{ minWidth: 120 }} variant="contained" onClick={() => { submit() }} endIcon={<SubmitIcon />}>Submit</Button>
                    </Box>
                    &nbsp;
                    &nbsp;
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
        </>
    )
}

export default AddEditPage